import {handleSend} from '../handleSend'

export const MerchantApi = {
  // 新增/修改商户资料
  handleMerchantInfo (data, type) {
    return handleSend(data, '34', '0001', String(type))
  },
  // 查询商户资料列表
  queryMerchantInfoList (data, isDesensit = 'true') {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '34', '0002', '0', 'message', isDesensit)
  },
  // 删除商户资料
  deleteMerchantInfo (data) {
    return handleSend(data, '34', '0003')
  },
  // 新增/修改商户设备区域接口（34,1001
  handleDeviceArea (data, type) {
    return handleSend(data, '34', '1001', String(type))
  },
  // 查询商户设备区域接口（34,1002
  queryDeviceAreaList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '34', '1002', '0', 'message')
  },
  // 删除商户设备区域接口（34,1003
  deleteDeviceArea (data) {
    return handleSend(data, '34', '1003')
  },
  // 新增/修改设备安装地点接口（34,2001
  handleDeviceInstallSite (data, type) {
    return handleSend(data, '34', '2001', String(type))
  },
  // 查询设备安装地点接口（34,2002
  queryDeviceInstallSiteList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '34', '2002', '0', 'message')
  },
  // 删除设备安装地点接口（34,2003
  deleteDeviceInstallSite (data) {
    return handleSend(data, '34', '2003')
  },
  // 新增/修改设备消费地点接口（34,3001
  handleDeviceConsumeSite (data, type) {
    return handleSend(data, '34', '3001', String(type))
  },
  // 查询设备消费地点接口（34,3002
  queryDeviceConsumeSiteList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '34', '3002', '0', 'message')
  },
  // 删除设备消费地点接口（34,3003
  deleteDeviceConsumeSite (data) {
    return handleSend(data, '34', '3003')
  }
}



// WEBPACK FOOTER //
// ./src/request/ApplyBasic/merchant_api.js